import { a as t } from "./array-slice-79f93c56.js";
var q = t, z = Math.floor, c = function(v, w) {
  var M = v.length;
  if (M < 8)
    for (var S = 1, $, o; S < M; ) {
      for (o = S, $ = v[S]; o && w(v[o - 1], $) > 0; )
        v[o] = v[--o];
      o !== S++ && (v[o] = $);
    }
  else
    for (var f = z(M / 2), h = c(q(v, 0, f), w), u = c(q(v, f), w), b = h.length, k = u.length, a = 0, s = 0; a < b || s < k; )
      v[a + s] = a < b && s < k ? w(h[a], u[s]) <= 0 ? h[a++] : u[s++] : a < b ? h[a++] : u[s++];
  return v;
}, B = c;
export {
  B as a
};
